import { create } from 'zustand';

/**
 * FIX-B17 (D-198 QX-147) — a task paused by "אני על זה" stays paused when the
 * employee left "אני על זה" with "עצירה ומעבר". When the NEXT timer stops the
 * server returns it once (`resume_offer`), and "להמשיך את [משימה]?" is offered
 * — never started by itself (like after a break, PRESERVE #4).
 */
export interface PausedResumeItem {
  timer_id?: string;
  ticket_id: string;
  ticket_title: string | null;
}

interface PausedResumeState {
  offered: PausedResumeItem[];
  offer: (items: PausedResumeItem[] | null | undefined) => void;
  clear: () => void;
}

/** Pure: the queue after new items arrive (one entry per task). */
export function mergePausedOffer(current: PausedResumeItem[], items: PausedResumeItem[] | null | undefined): PausedResumeItem[] {
  if (!items || items.length === 0) return current;
  const known = new Set(current.map((o) => o.ticket_id));
  const add = items.filter((i) => !known.has(i.ticket_id));
  return add.length === 0 ? current : [...current, ...add];
}

export const usePausedResumeStore = create<PausedResumeState>((set) => ({
  offered: [],
  offer: (items) => set((s) => {
    const next = mergePausedOffer(s.offered, items);
    return next === s.offered ? s : { offered: next };
  }),
  clear: () => set({ offered: [] }),
}));

/** Called with a stop / finish response: queues its `resume_offer`, if any. */
export function offerPausedResume(items: PausedResumeItem[] | null | undefined): void {
  if (!items || items.length === 0) return;
  usePausedResumeStore.getState().offer(items);
}
